// extracted by mini-css-extract-plugin
export default {"resizer":"resizer--mfe8W","handle":"handle--_HxSv","dragging":"dragging--qwkA0"};